export default __webpack_public_path__ + "static/media/Padron_DeliciasOpen.9613a440.jpg";